import React from 'react'
import { useNavigate } from 'react-router-dom'
import { match } from 'ts-pattern'

import { Button } from '@frame/ui-primitives/button'

import { PayrollProviderInfo, PlatformInfoType } from '@frame/components/screens/non-terminal/payroll-provider-info'
import { useDirectTask } from '@frame/lib/hooks/useDirectTask'
import { ItemKind } from '@frame/lib/hooks/useGetItems'
import { routes } from '@frame/routes'

type Props = {
  kind: ItemKind
  employerName?: string
}

export function WaitingForSearch({ kind, employerName }: Props) {
  const navigate = useNavigate()
  const task = useDirectTask()

  function goToPlatformSearch() {
    const params = new URLSearchParams(location.search)
    if (employerName) {
      params.set('employerName', employerName)
    }
    if (task?.id) {
      navigate(`${routes.platformSearch}/${task.id}?${params.toString()}`)
    } else {
      navigate(`${routes.platformSearch}?${params.toString()}`)
    }
  }

  return match(kind)
    .with(ItemKind.PLATFORM, ItemKind.BENEFITS, () => (
      <div className="mt-6 flex flex-col justify-between text-center">
        <p className="text-sm font-medium text-moss-700">Start typing to find the payroll provider</p>
        <PayrollProviderInfo type={PlatformInfoType.PLATFORM_SEARCH} className="mt-6" />
      </div>
    ))
    .with(ItemKind.EMPLOYER, ItemKind.GIG, () => (
      <div className="mt-6 flex flex-col justify-between text-center">
        <p className="text-sm text-moss-700">Start typing to view available employers</p>
        <p className="text-sm text-moss-700">or</p>
        <Button
          onClick={goToPlatformSearch}
          size="small"
          intent="primary"
          border={false}
          className="text-sm font-medium"
          fullWidth={false}
        >
          Search Payroll Provider
        </Button>
      </div>
    ))
    .with(ItemKind.INCOME, () => (
      <div className="mt-6 flex flex-col justify-between text-center">
        <p className="text-sm font-medium text-moss-700">Waiting for results...</p>
      </div>
    ))
    .exhaustive()
}
